import { enUS } from '@clerk/localizations';

export const defaultResource = enUS;
